// extracted by mini-css-extract-plugin
export var fadeInOut = "_2v-3";
export var icon = "_2v-4";
export var savedIndicator = "_2v-2";
export var savingIndicator = "_2v-0";
export var spin = "_2v-1";